import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { Toolbar } from '@mui/material';
import Header from '@shared/components/Header';
import TopPage from './Top';
const TopRoutes = () => {
    return (React.createElement(React.Fragment, null,
        React.createElement(Header, null),
        React.createElement(Toolbar, null),
        React.createElement(Routes, null,
            React.createElement(Route, { path: "/", element: React.createElement(TopPage, null) }))));
};
export default TopRoutes;
